import { consts } from './constants'

const fapp = feathers()

const wfetch = (url, options) => {
    options.credentials = 'include'
    options.headers['x-app-id'] = 'app'
    options.headers['x-app-ver'] = consts.version
    return fetch(url, options)
}

const restClient = feathers.rest(consts.apiUrl)
fapp.configure(restClient.fetch(wfetch.bind(window)))

/*fapp.service('/api/messages').hooks({
    after: {
        find: [async (context, b, c) => {
            console.log('hookFunction2!!!!!!!!!!!!!!!')
            console.log(context)
            console.log(b, c)
        }]
    }
})*/

fapp.configure(feathers.authentication({
    path: '/api/auth',
    storageKey: 'jwt'
}))

fapp.on('login', async ({ user, accessToken }) => {
    console.log('On login!!!!!!!!!!!!!')
    window._app.onLogin({user, accessToken})
    /**/
    /*fwapp.authentication.authenticated = true
    fwapp.authentication.setAccessToken(token).then(_ =>{
        fwapp.reAuthenticate()
    })*/
})

fapp.on('logout', () => {
    console.log('On logout!!!!!!!!!!!!!!!!')
    window._app.onLogout()
})

export { fapp }